import React, { Component } from 'react'
import { Field } from 'redux-form'
import { RelatorioDeveloperForm, SwitchItem, Item } from 'scorpion-core'
import ConvidarPerfil from '../../../../admin/ConsultaPerfisAdmin/componentes/ConvidarPerfil';
export default class OkReportDeveloperForm extends Component {
    componentDidMount() {
        this.props.listarPerfis();
    }
    render() {
        let metasAdd = [<ConvidarPerfil key={"userEditar"} label="Users Editar" />,
        <ConvidarPerfil key={"userVer"} label="Users Ver" name={"viewers"} />,
        <Item key={"publicoField"}>
            <Field name="publico" placeholder="Publico?(CUIDADO)" component={SwitchItem} />
        </Item>,
        <Item key={"concluidoField"}>
            <Field name="concluido" placeholder="Concluido" component={SwitchItem} />
        </Item>

        ]

        let metaRelatorio = {
            textoCabecalho1: "OK Desenvolvimento de Software",
            textoCabecalho2: "Dourados-MS - Fone.: (67) 3038-0338",
            textoRodape1: "rodape ",
            textoRodape2: "Emitido po Scorpion Core",
        }
        return (<RelatorioDeveloperForm {...this.props} metasAdd={metasAdd} metaRelatorio={metaRelatorio} />)

    }
}



// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/components/OkReportDeveloperForm/OkReportDeveloperForm.js